module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-DRIBBBLE.5b47ca0a.png";